import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getToken = () => localStorage.getItem("triad-token");
export const setToken = (t) => (t ? localStorage.setItem("triad-token", t) : localStorage.removeItem("triad-token"));

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const assetUrl = (id) => {
  const t = getToken();
  return `${API}/assets/${id}/raw${t ? `?token=${encodeURIComponent(t)}` : ""}`;
};

export const fileUrl = (id) => {
  const t = getToken();
  return `${API}/files/${id}/raw${t ? `?token=${encodeURIComponent(t)}` : ""}`;
};

export const MODEL_META = {
  anthropic: { label: "Claude", color: "#D97757" },
  openai: { label: "ChatGPT", color: "#10A37F" },
  gemini: { label: "Gemini", color: "#7C3AED" },
  image: { label: "Image", color: "#C77D0A" },
};

export const MODEL_LABELS = {
  "claude-sonnet-4-6": "Claude Sonnet 4.6",
  "claude-opus-4-8": "Claude Opus 4.8",
  "claude-haiku-4-5-20251001": "Claude Haiku 4.5",
  "gpt-5.4": "GPT-5.4",
  "gpt-5.5": "GPT-5.5",
  "gpt-5.4-mini": "GPT-5.4 Mini",
  "gpt-4o": "GPT-4o",
  "gemini-3.1-pro-preview": "Gemini 3.1 Pro",
  "gemini-3.5-flash": "Gemini 3.5 Flash",
  "gemini-2.5-pro": "Gemini 2.5 Pro",
  "nano-banana": "Nano Banana · Image",
  "gpt-image-1": "GPT Image 1 · Image",
};

export const modelLabel = (m) => MODEL_LABELS[m] || m;

export function errDetail(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    throw new Error("no clipboard api");
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
